import React, { useEffect, useState } from 'react'
import PublicWebsitePage from './pages/PublicWebsitePage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import TermsAndConditionsPage from './pages/TermsAndConditionsPage'
import { startAnalytics } from './services/analytics'

export default function App() {
  const [pathname, setPathname] = useState(() => window.location.pathname.replace(/\/+$/, '') || '/')

  useEffect(() => {
    startAnalytics()
    const onPopState = () => setPathname(window.location.pathname.replace(/\/+$/, '') || '/')
    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [])

  if (pathname === '/terms-and-conditions') return <TermsAndConditionsPage />
  if (pathname === '/privacy') return <PrivacyPolicyPage />
  return <PublicWebsitePage />
}
